export const REGEX_PATTERN = {
  EMAIL_NON_ACCEPT_CHARACTER: /[^a-zA-Z0-9.\-@_]/,
  EMAIL_NAME_INVALID_COUPLE_CHAR: /[.\-_]{2,}/,
  NON_NUMBER_OR_CHAR: /[^a-zA-Z0-9]/g,
  EMAIL_DOMAIN_INVALID_COUPLE_CHAR: /[.-]{2,}/,
  EMAIL_PATTERN:
    /^([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*[.-][a-zA-Z0-9]{1,})$/,
};
